
const SvgComponent = ({
    ...props
}: React.SVGProps<SVGSVGElement>) => {
    const w = 38
    const h = 29
    return (
        <svg width={w} height={h} viewBox="0 0 38 29" fill="none" xmlns="http://www.w3.org/2000/svg"  {...props}>
            <path d="M5.4375 3.55078H14.625V15.8008H36.5V24.1133H33" stroke="black" strokeWidth="2" strokeLinecap="round" />
            <path d="M25.125 24.1133L14.625 24.1133" stroke="black" strokeWidth="2" strokeLinecap="round" />
            <path d="M6.75 24.1133H1.5L5.4375 3.55078" stroke="black" strokeWidth="2" strokeLinecap="round" />
            <circle cx="10.6875" cy="23.6758" r="3.9375" stroke="black" strokeWidth="2" />
            <circle cx="29.0625" cy="23.6758" r="3.9375" stroke="black" strokeWidth="2" />
            <path d="M15.5 15L22.8333 1H28.3333V6.92308" stroke="black" strokeWidth="2" strokeLinecap="round" />
            <path d="M26.0011 10.6711C26.0041 9.21275 26.5306 6.72374 28.6306 6.72812C30.7306 6.73249 31.2501 9.35858 31.2474 10.6711" stroke="black" strokeWidth="2" strokeLinecap="round" />
            <path d="M3.25 15.8008L15.0625 15.8008" stroke="black" strokeWidth="2" strokeLinecap="round" />
        </svg>

    )
}

export default SvgComponent
